

import { jsPDF } from "jspdf";
// import { toBahtText } from "utils/toBahtText";
import "resource/font/THSarabun-normal"
import "resource/font/THSarabun-bold"
import dayjs from "dayjs";
import { printHeader } from "branch/functions/pirntHeader";
import { blue, cyan, green, lime, orange, red } from "@mui/material/colors";
import { subStringTH } from "utils/substringTH";

export const printDailyDriverStatus = ({msData, dataTable, dataColumn, dteSt, dteEn }) => {



  const pageSize = [9.96, 14.04];
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "in",
    format: pageSize
  });
  doc.setLineWidth(0.01)
  doc.setFont("THSarabun")
  const startY = 0.2
  const startX = 0.5
  let yPos = startY
  let xPos = startX

  //--------------------Group Data----------------------
  const printRow = dataTable.map((row) => ({ ...row }))
  const printCols = dataColumn.map((col) => ({ ...col }))
  if (printCols.length > 13) {
    printCols.splice(3, printCols.length - 13)
  }

  // dataTable.push([
  //   { text: `ยอดรวมค่าใช้จ่ายล่วงหน้า`, x: colTransport },
  //   { text: `${numberFormat(sumCustRcpt)} บาท`, x: whtAmntCol, align: "right" }
  // ])
  // dataTable.push([
  //   { text: `ยอดชำระในใบแจ้งหนี้นี้`, x: colTransport },
  //   { text: `${numberFormat(invPay)} บาท`, x: whtAmntCol, align: "right" }
  // ])


  //---------------------------------------------Start Print-----------------------------------------------------------


  const companyData = msData.serverData.CompanyData
  const lineHeight = 0.21
  const contentSize = 14
  let pageNo = 1

  doc.setFont("THSarabun")

  if (pageNo !== 1) {
    doc.addPage(pageSize, "portrait")
  }
  xPos = startX
  yPos = startY
  yPos = printHeader({ jsPDFDoc: doc, companyData, startX: xPos, startY: yPos })


  //----------------------------------------------- Top right data ------------------------------------------------
  yPos = startY + 0.2
  doc.setFont("THSarabun", "bold")
  doc.setFontSize(22)
  doc.text("รายงานการวิ่งรถประจำวัน", 10, yPos, { align: "center" })

  doc.setFont("THSarabun", "bold")
  doc.setFontSize(contentSize)
  const lineHeightTopRight = lineHeight + lineHeight / 5
  const yPosTopRight = yPos + lineHeightTopRight
  const xPosTopRight = 9.7
  xPos = xPosTopRight
  yPos = yPosTopRight

  doc.text("วันที่ : ", xPos, yPos, { align: "right" })
  yPos += lineHeightTopRight
  doc.text("ถึง : ", xPos, yPos, { align: "right" })
  yPos += lineHeightTopRight
  doc.setFont("THSarabun", "normal")
  yPos = yPosTopRight
  xPos += 0.1
  doc.text(dayjs(dteEn).add(-10, 'day').format("DD/MM/YYYY"), xPos, yPos)
  yPos += lineHeightTopRight
  doc.text(dayjs(dteEn).format("DD/MM/YYYY"), xPos, yPos)

  //----------------------------------------------- Draw Table ------------------------------------------------
  yPos += 0.2
  const startTableX = startX -0.2

  const dataBoxW = printCols.reduce((acc, col) => acc + (col.printWidth || 0.5), 0)
  
  xPos = startTableX
  yPos += lineHeight - 0.1
  doc.setFillColor(blue[100])
  doc.rect(xPos, yPos, dataBoxW, lineHeight + 0.1, "F")
  doc.line(xPos, yPos, xPos + dataBoxW, yPos)
  
  yPos += lineHeight
  xPos = startTableX

  const drawHeader = (label, width) => {
    console.log("label::", label)
    doc.text(label, xPos + width / 2, yPos, { align: "center" })
    xPos += width
  }
  const drawText = (text, width) => {
    console.log("text::", text)
    doc.text(text, xPos + 0.1, yPos, )
    xPos += width
  }

  for(const col of printCols){
    drawHeader(col.headerName, col.printWidth || 0.5)
  }
  
  yPos += 0.1
  doc.line(startTableX, yPos, startTableX + dataBoxW, yPos)
  yPos += lineHeight
  let forthColX = printCols[0].printWidth + printCols[1].printWidth + printCols[2].printWidth
  for(const row of printRow){
    xPos = startTableX
    for(const col of printCols){
      // const str = ["No", "DrvNm", "LicNm"].includes(col.field)? row[col.field]?.toString() || ""
      //   :row[col.field]?.text?.toString() || "" 
      console.log("row :: ", row)
      console.log("row[col.field]::", row[col.field])
      if(["No", "DrvNm", "LicNm"].includes(col.field)){
        drawText(row[col.field]? `${row[col.field]}` :"-", col.printWidth || 0.5)
      } else {
        const str = subStringTH(row[col.field]? row[col.field].text || "-" : "", 13 *(row[col.field]?.colSpan ||1))
        
        if(str){
          let color = ""
          if(row[col.field]?.className === "far"){
            color = green[400]
          } else if(row[col.field]?.className === "near"){
            color = cyan[400]
          } else if(row[col.field]?.className === "land"){
            color = orange[400]
          } else if(row[col.field]?.className === "other"){
            color = lime[400]
          } else if(row[col.field]?.className === "absent"){
            color = red[400]
          }
          if(color){
            doc.setFillColor(color)
            doc.rect(xPos, yPos+0.05-lineHeight, (col.printWidth || 0.5)*(row[col.field]?.colSpan ||1), lineHeight, "F")
            doc.line(xPos, yPos + 0.05 -lineHeight, xPos, yPos + 0.05)  
          }
        }
        drawText(str, col.printWidth || 0.5)
        doc.setLineWidth(0.001)
        doc.setLineDashPattern([0.01, 0.05], 0)
        doc.line(forthColX + 0.1, yPos + 0.05, startTableX + dataBoxW, yPos + 0.05 )
        doc.setLineDashPattern([], 0)
        doc.setLineWidth(0.01)
      }
    }
    yPos += lineHeight
  }
  //----------------------------------------------- Draw description  ------------------------------------------------


  const blob = new Blob([doc.output('blob')], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  
  // Open in new tab
  window.open(blobUrl, '_blank');
  
  // Clean up memory after a small delay
  
;
}